import palette from '../palette';

export default {
  root: {
    height: '2px',
    backgroundColor: palette.neutrals[3],
    width: '100%',
  },
};
